//! English with the day-first date order (FE #430). Not a moment locale:
//! moment's `en` long formats are month-first ("October 25, 2026") and its
//! `en-gb` also switches `LT` to 24-hour and starts the week on Monday. This
//! one is `en` with only the dates turned round, so the time still follows the
//! user's clock preference and nothing else moves. `Dates.setLocale` picks it
//! for English when the date order is day-first.

import moment from 'moment';

export default moment.defineLocale('en-dmy', {
  parentLocale: 'en',
  longDateFormat: {
    LT: 'h:mm A',
    LTS: 'h:mm:ss A',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    LLL: 'D MMMM YYYY h:mm A',
    LLLL: 'dddd, D MMMM YYYY h:mm A',
    // Spelled out: moment derives these from the uppercase forms on first
    // use and caches them, and a child locale copies its parent's cache, so
    // an `ll` formatted in `en` before this file ran would leak "MMM D, YYYY".
    l: 'D/M/YYYY',
    ll: 'D MMM YYYY',
    lll: 'D MMM YYYY h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
  },
});
